import ContentContainer from "Components/Container/ContentContainer";
import _ from "lodash";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { BREAKPOINTS } from "../../constants";
import DesktopLayout from "./components/DesktopLayout";
import MobileLayout from "./components/MobileLayout";
import ChatContextProvider from "./context/ChatContext";


const Message: React.FC = () => {
    const [isMobile, setIsMobile] = useState<undefined | boolean>(undefined);

    useEffect(() => {
        if (_.isUndefined(isMobile)) {
            setIsMobile(window.innerWidth <= BREAKPOINTS.TABLET)
        }
        window.addEventListener('resize', handleWindowSizeChange);

        return () => window.removeEventListener('resize', handleWindowSizeChange);
    }, [])

    function handleWindowSizeChange() {
        setIsMobile(window.innerWidth <= BREAKPOINTS.TABLET)
    }



    return (
        <ChatContextProvider>
            <ContentContainer classes="h-100">
                {_.isUndefined(isMobile) ?
                    < div className="h-100 d-flex align-items-center justify-content-center"> <Spinner /></div> :
                    isMobile ? < MobileLayout /> :
                        <DesktopLayout />
                }
            </ContentContainer>
        </ChatContextProvider >
    )
}

export default Message